"use client";

import { useDisplayCurrency } from "@/lib/displayCurrency";

/* Renders a USD-priced amount in the visitor's detected currency.
   Falls back to `$<usd>` on the server and until detection resolves so
   first paint is never empty. */
export function PriceTag({ usd, className }: { usd: number; className?: string }) {
  const { format, ready } = useDisplayCurrency();
  return (
    <span className={className} suppressHydrationWarning>
      {ready ? format(usd) : `$${usd}`}
    </span>
  );
}
